module.exports = __webpack_public_path__ + "static/energy_private_1-86475cb077d00cc48671d44788999656.jpg";